export enum BookEnum {
  MANGA = 'MANGA',
  NOVEL = 'NOVEL',
}

export const bookTypeValue = {
  [BookEnum.MANGA]: 'การ์ตูน',
  [BookEnum.NOVEL]: 'นิยาย',
}
